import React, { Component } from 'react'
import { InternalHotspots } from '../config/InternalHotspots'
import ZoomButtons from './ZoomButtons'
import { connect } from 'react-redux'
import 'pannellum'
import { makeFull } from '../store/actions'
import { getAssetFilePath } from '../js/getLocalFilePath'

class Interior extends Component {
  constructor (props) {
    super(props)

    this.state = {
      yaw: 0,
      pitch: 0,
    }
  }

  viewer = null
  defaultZoom = 0

  componentDidMount () {
    this.setViewer()

    this.defaultZoom = this.viewer.getHfov()
    window.addEventListener('resize', () => {
      this.viewer.getRenderer().resize()
    })
    document.querySelector('.three-sixty-spinner').addEventListener('fullscreenchange', () => {
      this.viewer.getRenderer().resize()
    })
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.modal && this.props.modal === null) {
      this.resetZoom()
    }

    if (prevProps.model !== this.props.model && this.viewer) {
      // destroy and rebuild once state set
      this.setState({
        yaw: this.viewer.getYaw(),
        pitch: this.viewer.getPitch()
      }, () => {
        this.viewer.destroy()
        this.setViewer()
      })
    }
  }

  setViewer = () => {
    const { yaw, pitch } = this.state

    this.viewer = window.pannellum.viewer('interior', {
      'hfov': 100.0,
      'type': 'multires',
      'multiRes': {
        'basePath': getAssetFilePath(`/images/interior/${this.props.model}`),
        'path': '/%l/%s%y_%x',
        'fallbackPath': '/fallback/%s',
        'extension': 'jpg',
        'tileResolution': 512,
        'maxLevel': 4,
        'cubeResolution': 2384
      },
      autoLoad: true,
      hotSpots: InternalHotspots(this.zoomToPoint),
      showFullscreenCtrl: false,
      showControls: false,
      orientationOnByDefault: true
    })

    this.viewer.setYaw(yaw, false)
    this.viewer.setPitch(pitch, false)
    this.viewer.setHfov(100, true)
  }

  resetZoom = () => {
    this.viewer.setHfov(this.defaultZoom)
  }

  zoomToPoint = (event, args) => {
    this.viewer.lookAt(args.pitch, args.yaw + 17)
    this.zoomIn()
  }

  zoomIn = () => {
    this.viewer.setHfov(this.viewer.getHfov() - 25)
  }

  zoomOut = () => {
    this.viewer.setHfov(this.viewer.getHfov() + 25)
  }

  onFullscreen = () => {
    const isInFullScreen = (document.fullscreenElement && document.fullscreenElement !== null) ||
      (document.webkitFullscreenElement && document.webkitFullscreenElement !== null) ||
      (document.mozFullScreenElement && document.mozFullScreenElement !== null) ||
      (document.msFullscreenElement && document.msFullscreenElement !== null);

    const docElm = document.querySelector('.three-sixty-spinner')
    if (!isInFullScreen) {
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen();
      } else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen();
      } else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen();
      } else if (docElm.msRequestFullscreen) {
        docElm.msRequestFullscreen();
      }
      this.props.makeFull(true)
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
      this.props.makeFull(false)
    }
  }

  render () {
    return (
      <div>
        <div className="interior" id="interior"></div>
        <ZoomButtons
          onZoomIn={this.zoomIn}
          onZoomOut={this.zoomOut}
          onReset={this.resetZoom}
          onFullscreen={this.onFullscreen}
        />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    modal: state.modal,
    fullScreen: state.fullScreen,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    makeFull: screen => dispatch(makeFull(screen))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Interior)
